import React from 'react';
import { Link } from 'react-router-dom';
import agent from '../agent';
import { connect } from 'react-redux';
import moment from 'moment';
import { ARTICLE_FAVORITED, ARTICLE_UNFAVORITED, UPDATE_FIELD_EDITOR, ANSWER_SUBMITTED, EDITOR_PAGE_LOADED } from '../constants/actionTypes';
import './question-card.css';

const mapDispatchToProps = dispatch => ({
  onLoad: payload => dispatch({
    type: EDITOR_PAGE_LOADED, payload
  }),
  favorite: id => dispatch({
    type: ARTICLE_FAVORITED,
    payload: agent.Articles.favorite(id)
  }),
  unfavorite: id => dispatch({
    type: ARTICLE_UNFAVORITED,
    payload: agent.Articles.unfavorite(id)
  }),
  onUpdateField: (key, value) => dispatch({
    type: UPDATE_FIELD_EDITOR, key, value
  }),
  onSubmit: payload => dispatch({
    type: ANSWER_SUBMITTED, payload
  }),
});

const mapStateToProps = state => ({
  ...state.editor,
  profile: state.profile
});

class QuestionCard extends React.Component {
  constructor(props) {
    super(props)
    this.handleReplyClick = this.handleReplyClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.state = { answerMode: false };

    const updateFieldEvent =
      key => ev => this.props.onUpdateField(key, ev.target.value);
    this.changeBody = updateFieldEvent('body');

    this.submitForm = ev => {
      ev.preventDefault();
      const promise = agent.Articles.answer({
        content: this.props.body,
        questionId: this.props.article.id
      });
      this.props.onSubmit(promise)
      this.props.article.answer = this.props.body
    };
  }

  componentWillMount() {
    this.props.onLoad()
  }

  handleReplyClick() {
    this.setState({ answerMode: true });
  }

  handleCancelClick() {
    this.setState({ answerMode: false });
  }

  // changeBody(ev) {
  //   this.props.onUpdateField('body', ev.target.value)
  // }

  // submitForm(ev) {
  //   ev.preventDefault();
  //   console.log('body', this.props.body)
  //   const promise = agent.Articles.answer({
  //     content: this.props.body,
  //     questionId: this.props.article.id
  //   });
  //   // this.props.onSubmit(promise);
  // };

  render() {
    const article = this.props.article;
    const handleClick = ev => {
      ev.preventDefault();
      if (this.props.currentUser && this.props.currentUser.verified && this.props.currentUser.openid && this.props.currentUser.preferredName) {
        if (this.props.blackout) {
          this.props.handleBlackout();
        }
        else if (article.hasVoted === '1') {
          this.props.unfavorite(article.id);
        } else {
          this.props.favorite(article.id);
        }
      } else {
        this.props.handleLogin()
      }
    };

    const getInitials = (fullName) => {
      console.log(`article is ${JSON.stringify(article)}`)
      let nameArr = fullName.split(" ")
      let initials = nameArr.map((n, i) => {
        return (i == 0 || i == nameArr.length - 1) && n[0]
      }).filter(n => n).join("")
      return initials
    }

    return (
      <div className="question-preview">
        <div className="question-top-container">
          <div className="question-left-container">
            <div className="question-ranking">
              # {article.rank}
            </div>
          </div>
          <div className="question-ctr-container">
            <div className="avatar">
              {getInitials(article.user.fullName ? article.user.fullName: article.user.preferredName)}
            </div>
            <div className="qn-meta-data">
              <div className="asker">
                {article.user.fullName ? article.user.fullName : article.user.preferredName}
              </div>
              <div className="timestamp">
                asked on {moment(article.createdAt).format('D MMMM YYYY')}
              </div>
            </div>
          </div>
          <div className="question-right-container">
            <div className="question-stats">
              <div className={article.hasVoted === '1' ? 'favorite' : 'not-favorite'}>
                {article.voteCount}
              </div>
              <div onClick={handleClick}>
                <i className={article.hasVoted === '1' ? 'bx bxs-heart' : 'bx bx-heart'}></i>
              </div>
            </div>
          </div>
        </div>
        <div className="question-bottom-container">
          <div className="question-text">
            {article.content}
          </div>
          {
            (() => {
              if (this.props.currentUser.id === this.props.profile.userId) {
                if (this.props.article.answer) {
                  return <div className="reply-button-container">
                    <div className="reply-button-answered">
                      Answered
                    </div>
                  </div>
                } else {
                  return <div className="reply-button-container">
                    <div className="reply-button" onClick={this.handleReplyClick}>
                      Reply
                    </div>
                  </div>
                }
              } else {
                return <div></div>
              }
            })()
          }
          {
            this.state.answerMode && !this.props.article.answer && <div className="reply-body">
              <div className="reply-header">
                Reply to Question
              </div>
              <textarea
                autoFocus
                rows="12"
                placeholder='Type your comment here...'
                value={this.props.body}
                onChange={this.changeBody}
              >
              </textarea>
              <div className="reply-bottom-container">
                <div className="reply-cancel-button" onClick={this.handleCancelClick}>
                  Cancel
                </div>
                <div className="reply-post-button" onClick={this.submitForm}>
                  Post
                </div>
              </div>
            </div>
          }
        </div>
        {/* <div className="question-left-container">
          <div className="question-ranking">
            #{article.rank}
          </div>
          <div className="question-text">
            {article.content}
          </div>
        </div>
        <div className="question-right-container">
          <div className="question-stats">
            <div className={ article.hasVoted === '1' ? 'favorite' : 'not-favorite' }>
              {article.voteCount}
            </div>
            <div onClick={handleClick}>
              <i className={ article.hasVoted === '1' ? 'bx bxs-heart' : 'bx bx-heart' }></i> 
            </div>
          </div>
        </div> */}



        {/* <div className="article-meta">
          <Link to={`/@${article.author.username}`}>
            <img src={article.author.image} alt={article.author.username} />
          </Link>

          <div className="info">
            <Link className="author" to={`/@${article.author.username}`}>
              {article.author.username}
            </Link>
            <span className="DottedBox">
              {new Date(article.createdAt).toDateString()}
            </span>
          </div>

          <div className="pull-xs-right">
            <button className={favoriteButtonClass} onClick={handleClick}>
              <i className="ion-heart"></i> {article.favoritesCount}
            </button>
          </div>
        </div> */}

        {/* <Link to={`/article/${article.slug}`} className="preview-link">
          <h1>{article.title}</h1>
          <p>{article.description}</p>
          <span>Read more...</span>
          <ul className="tag-list">
            {
              article.tagList.map(tag => {
                return (
                  <li className="tag-default tag-pill tag-outline" key={tag}>
                    {tag}
                  </li>
                )
              })
            }
          </ul>
        </Link> */}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionCard);



// WEBPACK FOOTER //
// ./src/components/QuestionCard.js